module.exports = __webpack_public_path__ + "img/empty-result-picture-data.2fe4cc11.png";